import { PaymentRequestDialogV2 } from '~/components/dashboard/invoices/payment/dialogs-v2/payment-request-dialog-v2/components/PaymentRequestDialogV2'
import { PaymentRequestDialogProvider } from '~/components/dashboard/invoices/payment/dialogs-v2/payment-request-dialog-v2/context/PaymentRequestDialogProvider'
import type { InvoiceOrEstimate } from '~/types'

export interface PaymentRequestDialogContainerV2Props {
  invoice: InvoiceOrEstimate
  isOpen: boolean
  onClose: () => void
  showStepper?: boolean
}

export const PaymentRequestDialogContainerV2 = ({
  invoice,
  isOpen,
  onClose,
  showStepper = false,
}: PaymentRequestDialogContainerV2Props) => (
  <PaymentRequestDialogProvider invoice={invoice}>
    <PaymentRequestDialogV2
      isOpen={isOpen}
      showStepper={showStepper}
      onClose={onClose}
    />
  </PaymentRequestDialogProvider>
)
